import { useState, useEffect, Fragment } from "react";
import { BASE_URL } from "../../utils/constants";
import CustomerSocialLink from "./CustomerSocialLink";
import CustomerAddress from "./CustomerAddress";
import CustomerContactPerson from "./CustomerContactPerson";
import { useFetchCustomerAddressDataBasedOnIdQuery } from "../../utils/customer/customerSelect";
import useRequireAuth from "../../utils/useRequireAuth";
import { useParams } from "react-router-dom";
import { useCustomerTableMutation, useDeleteCustomerDataMutation } from "../../utils/customer/customerTable";
import { ReactComponent as UploadIcon } from "../../assets/images/uploadIcon.svg";
import { pushAlert } from "../../utils/alertSlice";
import { useDispatch } from "react-redux";
import CustomerInfoDrawer from "../company/CustomerInfoDrawer";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import { ReactComponent as PersonAvatar } from "../../assets/images/personAvatar.svg";
import { ReactComponent as CameraIcon } from "../../assets/images/cameraIcon.svg";
import { valueColorCodeCheck } from "../../utils/utilityFunctions/valueColorCodeCheck";
import CustomerNewDashboard from "../CustomerNewDashboard";
import { ReactComponent as BackIcon } from "../../assets/images/back_arrow_black.svg";
import AuditLog from "../ActivityLogs/AuditLog";
import { ReactComponent as AuditLogIcon } from "../../assets/images/AuditLog.svg";

const CustomerHome = ({ leftTab, customerGData, setRefetch }) => {
  const [formData, setFormData] = useState({});

  const { token } = useRequireAuth();
  const { id: customerId } = useParams();
  const [isFormFrozen, setIsFormFrozen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  // const [customerGroups, setCustomerGroups] = useState([]);
  const [activeButton, setActiveButton] = useState("genInfo");
  //const parsedtypeData = Array.isArray(parseJSONValue(typeData)) ? parseJSONValue(typeData) : [];
  const [isContactUpdated, setIsContactUpdated] = useState(false);
  const [isAuditLog, setIsAuditLog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [addCustomerId, setAddCustomerId] = useState();
  // API DEFINITION
  const [deleteCustomerData] = useDeleteCustomerDataMutation();

  // new Node API
  const {
    data: customerAddress,
    refetch: refetchCustomerData,
    isFetching,
  } = useFetchCustomerAddressDataBasedOnIdQuery({ token, customerId });
  const dispatch = useDispatch();
  // const [CustomerTableDrop, { data: customerCommnData }] = useCustomerTableMutation();

  const closeModal = () => {
    setSelectedFile(null);
    setIsModalOpen(false);
  };

  const handleDelete = async (recordType, recordId) => {
    try {
      const response = await deleteCustomerData({
        recordType,
        customerId: Number(customerId),
        recordId: Number(recordId),
      });
      if (response?.data?.success) {
        dispatch(pushAlert({ visible: true, message: "Record Deleted Successfully", type: "success" }));
        setRefetch((prev) => !prev);
      } else {
        dispatch(pushAlert({ visible: true, message: "Something Went Wrong.", type: "danger" }));
      }
      refetchCustomerData();
    } catch (error) {
      console.error("Error updating status:", error);
      dispatch(
        pushAlert({
          visible: true,
          message: error,
          type: "danger",
        })
      );
    }
  };

  // Effect to handle the keydown event for closing the modal
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        closeModal(); // Close the modal when "Esc" is pressed
      }
    };

    // Adding the event listener
    window.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(URL.createObjectURL(file));
    }
  };

  const fetchData = async () => {
    // const parsedResponse = parseJSONFields(customerAddress?.data[0]);
    // setCustomerData(customerGData?.data[0]?.customer_data?.[0]);
    setFormData(customerGData?.data?.[0]?.customer_data?.[0]);
  };

  useEffect(() => {
    fetchData();
  }, [customerAddress]);

  const openModal = async (e) => {
    e.preventDefault();
    setIsModalOpen(true);
    fetchData();
    const completedata = {
      model_name: "customers",
      field_name: "type",
    };
  };

  useEffect(() => {
    if (isFetching) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [isFetching]);

  const handleAuditLog = () => {
    setIsAuditLog(true);
  };

  return (
    <Fragment>
      {isAuditLog ? (
        <div className="flex flex-col gap-2 h-full">
          <div>
            <span
              className="cursor-pointer flex gap-3 mt-2 text-xl font-medium text-[#383838] items-center text-center"
              onClick={() => setIsAuditLog(false)}
            >
              <BackIcon /> Audit Log
            </span>{" "}
          </div>
          <AuditLog customerId={customerId} />
        </div>
      ) : (
        <div className="flex flex-col gap-2 h-full">
          <div className="flex justify-between">
            <div className="flex items-center gap-2 ml-2">
              <h2 className="text-lg text-[#004EFF] font-semibold">Customer Overview</h2>
              <button className="py-1 px-2 text-xs text-[#666666] border-b border-[#666666]" onClick={openModal}>
                View Customer Details
              </button>
            </div>
            <div className="me-5">
              <button
                onClick={handleAuditLog}
                className="border border-[#1313133d] text-[#131313cc] text-sm hover:shadow-cardLight font-semibold rounded-full px-3 py-1.5 flex items-center gap-2"
              >
                <AuditLogIcon /> Audit log
              </button>
            </div>
          </div>
          <CustomerNewDashboard customerId={customerId} />
        </div>
      )}
      {isModalOpen && (
        <CustomerInfoDrawer
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          handleDelete={handleDelete}
          isEditMode={isEditMode}
          setIsEditMode={setIsEditMode}
          addCustomerId={customerId}
          setAddCustomerId={setAddCustomerId}
        />
      )}
    </Fragment>
  );
};

export default CustomerHome;
